// src/components/TemplateCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import TemplateMiniPreview from './TemplateMiniPreview';

// Datos de ejemplo DISTINTOS para cada plantilla
const DEMO_BY_SLUG = {
  // --- Matrimonios ---
  'boda-clasica':  { bride: 'María',   groom: 'Carlos', date: '2026-12-12', place: 'Hacienda San José' },
  'boda-elegante': { bride: 'Sofía',   groom: 'Andrés', date: '2026-11-08', place: 'Hotel Costa del Sol' },
  'boda-boho':     { bride: 'Lucía',   groom: 'Mateo',  date: '2026-10-25', place: 'Playa Máncora' },

  // --- Cumpleaños ---
  'cumple-infantil': { name: 'Sofía',   age: 5, date: '2026-11-20', place: 'Salón Mágico' },
  'cumple-tematico': { name: 'Mateo',   age: 7, date: '2026-09-15', place: 'Aventura Park' },
  'cumple-juvenil':  { name: 'Camila',  age: 15, date: '2026-12-05', place: 'Rooftop Lounge' },

  // --- Baby Shower ---
  'baby-shower-azul':   { babyName: 'Mateo',  parents: 'Ana & Luis',   date: '2026-10-15', place: 'Casa de la familia' },
  'baby-shower-rosa':   { babyName: 'Emma',   parents: 'Carla & Diego', date: '2026-11-02', place: 'Jardín de Rosas' },
  'baby-shower-neutro': { babyName: 'Noah',   parents: 'Sofía & Andrés', date: '2026-10-28', place: 'Terraza del Valle' },

  // --- Bautizos ---
  'bautizo-dorado':    { child: 'Isabella', date: '2026-11-08', church: 'Parroquia San Pedro' },
  'bautizo-celestial': { child: 'Santiago', date: '2026-10-20', church: 'Catedral de Arequipa' },
  'bautizo-jardin':    { child: 'Valentina', date: '2026-12-01', church: 'Capilla Santa María' },

  // --- Graduaciones ---
  'graduacion-moderna':  { graduate: 'Diego Ramírez', career: 'Ingeniería de Sistemas', date: '2026-12-20', place: 'Centro de Convenciones' },
  'graduacion-elegante': { graduate: 'Valeria Torres', career: 'Medicina',                date: '2026-11-28', place: 'Auditorio UNSA' },
  'graduacion-juvenil':  { graduate: 'Sebastián Ríos', career: 'Administración',           date: '2026-12-10', place: 'Hotel Libertador' },
};

export default function TemplateCard({ template, onSelect }) {
  const demo = DEMO_BY_SLUG[template.slug] || {};

  return (
    <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition group">
      <Link to={`/preview/${template.slug}`} className="block">
        <div className="aspect-[3/4] relative overflow-hidden">
          <TemplateMiniPreview
            slug={template.slug}
            category={template.category}
            data={demo}
            size="md"
          />

          {/* Overlay con botón al hacer hover */}
          <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition grid place-items-center">
            <span className="bg-white text-slate-800 text-xs font-semibold px-4 py-2 rounded-lg shadow-lg">
              Ver vista previa completa
            </span>
          </div>
        </div>
      </Link>

      <div className="p-4 flex items-center justify-between gap-2">
        <div className="min-w-0">
          <h3 className="font-bold text-slate-800 text-sm truncate">{template.name}</h3>
          <p className="text-xs text-slate-500">{template.category}</p>
        </div>
        <div className="flex gap-1 flex-shrink-0">
          <Link
            to={`/preview/${template.slug}`}
            className="text-xs font-semibold text-slate-600 hover:text-brand-600 px-2 py-1"
          >
            Ver
          </Link>
          <button
            onClick={onSelect}
            className="text-xs font-semibold bg-brand-500 text-white px-3 py-1.5 rounded-lg hover:bg-brand-600"
          >
            Usar
          </button>
        </div>
      </div>
    </div>
  );
}